if (!customElements.get('neji-slider')) {
  customElements.define('neji-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.nf-slide-track');
      const slides = Array.from(track.children);
      const buttons = Array.from(this.querySelectorAll('[data-slide]'));
      const go = (index) => {
        const bounded = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[bounded].offsetLeft - slides[0].offsetLeft,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      buttons.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.slide))));
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        go(Math.round(track.scrollLeft / track.clientWidth) + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        buttons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.slide) === index)));
      }, { passive: true });
    }
  });
}
